export const getSelectedCreneaux= (state) => state?.selectedCreneaux//return current selected creneaux

export const getEleves= (state) => state?.eleves//return current list of eleves

export const getFormules= (state) => state?.formules//return current list of formules

export const getFormulesEleves= (state) => state?.formulesEleves//return current list of formules

export const getCommentaire= (state) => state?.commentaire//return commentaire

export const getClient= (state) => state?.client//return colient

export const getResa= (state) => state?.resa//return resa

export const getLang = (state) => state?.lang; //return selected language

export const getStepLocation = (state) => state?.stepLocation; //return selected language

export const getLocation = (state) => state?.location; //return selected language

export const getPanier = (state) => state?.panier; //return selected language